import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from "swiper";


import { createPopper } from '@popperjs/core';



import '../../assets_2v/css/fires.css';
import '../../assets_2v/css/root.css';
import '../../assets_2v/css/style.css';


import bannerIMG from '../../assets_2v/images/compressed/archon-banner.png'
import logo from '../../assets_2v/images/logo.svg'
import tableIMG from '../../assets_2v/images/table.png'
import archonChainIMG from "../../assets_2v/images/compressed/archon-chain.png";
import archonTitleIMG from '../../assets_2v/images/archon.png';
import socialElementIMG from '../../assets_2v/images/compressed/The Social Element.png'
import mature1 from '../../assets_2v/images/mature-01.png'
import mature2 from '../../assets_2v/images/mature-02.png'
import mature3 from '../../assets_2v/images/mature-03.png'


function App() {



  const sandwichClick = (e) => {
    e.currentTarget.closest('body').classList.toggle('nav-open')

  }

  const checkMenu = (y) => {
    const top = y || -document.querySelector('.js-container').getBoundingClientRect().top
    if (top > 90) {
      document.body.classList.add('scrolled')
    } else {
      document.body.classList.remove('scrolled')
    }
  }



  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [isVisible4, setIsVisible4] = useState(false);
  const [isVisible5, setIsVisible5] = useState(false);


  const buttonRef = React.createRef();
  const tooltipRef = React.createRef();

  const buttonRef2 = React.createRef()
  const tooltipRef2 = React.createRef()

  const buttonRef3 = React.createRef()
  const tooltipRef3 = React.createRef()

  const buttonRef4 = React.createRef()
  const tooltipRef4 = React.createRef()

  const buttonRef5 = React.createRef()
  const tooltipRef5 = React.createRef()




  useEffect(() => {
    if (buttonRef.current && tooltipRef.current) {
      createPopper(buttonRef.current, tooltipRef.current, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          }
        ],

      });
    }
  }, [buttonRef, tooltipRef]);

  useEffect(() => {
    if (buttonRef2.current && tooltipRef2.current) {
      createPopper(buttonRef2.current, tooltipRef2.current, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          }
        ],

      });
    }
  }, [buttonRef2, tooltipRef2]);

  useEffect(() => {
    if (buttonRef3.current && tooltipRef3.current) {
      createPopper(buttonRef3.current, tooltipRef3.current, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          }
        ],

      });
    }
  }, [buttonRef3, tooltipRef3]);

  useEffect(() => {
    if (buttonRef4.current && tooltipRef4.current) {
      createPopper(buttonRef4.current, tooltipRef4.current, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          }
        ],

      });
    }
  }, [buttonRef4, tooltipRef4]);

  useEffect(() => {
    if (buttonRef5.current && tooltipRef5.current) {
      createPopper(buttonRef5.current, tooltipRef5.current, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          }
        ],

      });
    }
  }, [buttonRef5, tooltipRef5]);



  const handleHover = (key) => {
    switch (key) {
      case 1:
        setIsVisible(true)
        break;
      case 2:
        setIsVisible2(true)
        break;
      case 3:
        setIsVisible3(true)
        break;
      case 4:
        setIsVisible4(true)
        break;
      case 5:
        setIsVisible5(true)
        break;


      default:
        break;
    }

  }

  const handleClick = (key) => {
    switch (key) {
      case 1:
        setIsVisible(true)
        break;
      case 2:
        setIsVisible2(true)
        break;
      case 3:
        setIsVisible3(true)
        break;
      case 4:
        setIsVisible4(true)
        break;
      case 5:
        setIsVisible5(true)
        break;


      default:
        break;
    }

  }

  const handleOver = (key) => {
    switch (key) {
      case 1:
        setIsVisible(false)
        break;
      case 2:
        setIsVisible2(false)
        break;
      case 3:
        setIsVisible3(false)
        break;
      case 4:
        setIsVisible4(false)
        break;
      case 5:
        setIsVisible5(false)
        break;


      default:
        break;
    }
  }




  const handleScroll = () => {
    setIsVisible(false);
    setIsVisible2(false);
    setIsVisible3(false);
    setIsVisible4(false);
    setIsVisible5(false);
  };


  useEffect(() => {


    // Toggle this boolean to hide/show the original video alongside the canvas version of the video.
    var hideOrig = false;

    // draws the current frame from the video, then sets a timeout to do it again (roughly 30 FPS).
    var drawFrame = function (v, c) {
      if (v.paused || v.ended) return false;
      var w = v.videoWidth;
      var h = v.videoHeight;
      c.canvas.width = w;
      c.canvas.height = h;
      c.drawImage(v, 0, 0, w, h);
      v.timeout = setTimeout(drawFrame, 20, v, c);
    }

    // creates a canvas element, inserts it, and begins drawing video frames
    document.querySelectorAll('[data-replace-video-with-canvas]').forEach(function (v) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      v.parentNode.appendChild(canvas);
      if (hideOrig) v.classList.add('shy');

      drawFrame(v, ctx);

      v.addEventListener('playing', function () {
        if (typeof v.timeout === 'number') clearTimeout(v.timeout);
        drawFrame(this, ctx);
      });
    });



    document.querySelectorAll('.js-m-click').forEach(item => {
      item.onclick = (e) => {
        const parent = e.currentTarget.closest('.swiper-slide')
        parent.classList.toggle('show-popup')
      }
    })




    document.querySelector('#root').onscroll = (e) => {
      if (e.currentTarget) {
        checkMenu(e.currentTarget.scrollTop)
      }
      if (window.innerWidth < 1024) {
        handleScroll()
      }

    }


    window.onresize = () => {
      const y = document.querySelector('#root').scrollTop
      checkMenu(y)
    }



  }, [])


  return (

    <div className="container-overflow-hidden js-container"  >
      <div className="header-wrap">
        <header>

          <div className="header container">
            <div className="sandwich js-sandwich" onClick={sandwichClick}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_803_2242)">
                  <path d="M15 16H3V14H15V16ZM21 9H3V7H21V9Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_803_2242">
                    <rect width="24" height="24" fill="white" transform="translate(24 24) rotate(-180)" />
                  </clipPath>
                </defs>
              </svg>




            </div>


            <div className="logo__wrap">
              <a className="logo" href="#Start">
                <img style={{ display: 'block' }} src={logo} alt="" />
              </a>
            </div>
            <nav className="header__nav">
              <ul className="header__list">
                <li className="header__item">
                  <a className="header__link" href="#ProtocolArchitecture">
                    Protocol Overview
                  </a>
                </li>
                <li className="header__item">
                  <a className="header__link" href="#ArchonChain">
                    Archon Chain
                  </a>
                </li>
                <li className="header__item">
                  <a className="header__link" href="#TheSocialElement">
                    Social Element
                  </a>
                </li>
                <li className="header__item">
                  <a className="header__link" href="#ResearchObjects">
                    Biolinks
                  </a>
                </li>
                <li className="header__item">
                  <a className="header__link" href="#EconomyOfParticipation">
                    Economy
                  </a>
                </li>
                <li className="header__item">
                  <a className="header__link" href="#MaturityOfResearch">
                    Research
                  </a>
                </li>
              </ul>
              {/* <ul className="socials__list">
                        <li className="socials__item">
                            <a className="socials__link" href="#">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_803_2136)">
                                        <path
                                            d="M18.335 18.339H15.67V14.162C15.67 13.166 15.65 11.884 14.28 11.884C12.891 11.884 12.679 12.968 12.679 14.089V18.339H10.013V9.75H12.573V10.92H12.608C12.966 10.246 13.836 9.533 15.136 9.533C17.836 9.533 18.336 11.311 18.336 13.624V18.339H18.335ZM7.003 8.575C6.79956 8.57526 6.59806 8.53537 6.41006 8.45761C6.22207 8.37984 6.05127 8.26574 5.90746 8.12184C5.76365 7.97793 5.64965 7.80706 5.57201 7.61901C5.49437 7.43097 5.4546 7.22944 5.455 7.026C5.4552 6.71983 5.54618 6.4206 5.71644 6.16615C5.8867 5.91169 6.12859 5.71343 6.41153 5.59645C6.69447 5.47947 7.00574 5.44902 7.30598 5.50894C7.60622 5.56886 7.88196 5.71647 8.09831 5.93311C8.31466 6.14974 8.46191 6.42566 8.52145 6.72598C8.58099 7.0263 8.55013 7.33753 8.43278 7.62032C8.31544 7.9031 8.11687 8.14474 7.86219 8.31467C7.60751 8.4846 7.30817 8.5752 7.002 8.575H7.003ZM8.339 18.339H5.666V9.75H8.34V18.339H8.339ZM19.67 3H4.329C3.593 3 3 3.58 3 4.297V19.703C3 20.42 3.594 21 4.328 21H19.666C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3H19.669H19.67Z"
                                            fill="black"></path>
                                        <path
                                            d="M18.335 18.339H15.67V14.162C15.67 13.166 15.65 11.884 14.28 11.884C12.891 11.884 12.679 12.968 12.679 14.089V18.339H10.013V9.75H12.573V10.92H12.608C12.966 10.246 13.836 9.533 15.136 9.533C17.836 9.533 18.336 11.311 18.336 13.624V18.339H18.335ZM7.003 8.575C6.79956 8.57526 6.59806 8.53537 6.41006 8.45761C6.22207 8.37984 6.05127 8.26574 5.90746 8.12184C5.76365 7.97793 5.64965 7.80706 5.57201 7.61901C5.49437 7.43097 5.4546 7.22944 5.455 7.026C5.4552 6.71983 5.54618 6.4206 5.71644 6.16615C5.8867 5.91169 6.12859 5.71343 6.41153 5.59645C6.69447 5.47947 7.00574 5.44902 7.30598 5.50894C7.60622 5.56886 7.88196 5.71647 8.09831 5.93311C8.31466 6.14974 8.46191 6.42566 8.52145 6.72598C8.58099 7.0263 8.55013 7.33753 8.43278 7.62032C8.31544 7.9031 8.11687 8.14474 7.86219 8.31467C7.60751 8.4846 7.30817 8.5752 7.002 8.575H7.003ZM8.339 18.339H5.666V9.75H8.34V18.339H8.339ZM19.67 3H4.329C3.593 3 3 3.58 3 4.297V19.703C3 20.42 3.594 21 4.328 21H19.666C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3H19.669H19.67Z"
                                            fill="url(#paint0_linear_803_2136)"></path>
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_803_2136" x1="21" y1="11.6792" x2="2.59561"
                                            y2="13.5388" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#00C4B8"></stop>
                                            <stop offset="1" stopColor="#0ACE88"></stop>
                                        </linearGradient>
                                        <clipPath id="clip0_803_2136">
                                            <rect width="24" height="24" fill="white"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>

                            </a>
                        </li>
                        <li className="socials__item">
                            <a className="socials__link" href="#">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_803_2139)">
                                        <path
                                            d="M22.1603 5.65593C21.3969 5.99362 20.5873 6.2154 19.7583 6.31393C20.6321 5.79136 21.2861 4.96894 21.5983 3.99993C20.7783 4.48793 19.8793 4.82993 18.9423 5.01493C18.313 4.34151 17.4787 3.89489 16.5693 3.74451C15.6599 3.59413 14.7263 3.74842 13.9136 4.18338C13.1009 4.61834 12.4547 5.30961 12.0755 6.14972C11.6962 6.98983 11.6051 7.93171 11.8163 8.82893C10.1535 8.74558 8.52668 8.31345 7.04163 7.56059C5.55659 6.80773 4.24647 5.75097 3.19634 4.45893C2.82463 5.09738 2.6293 5.82315 2.63034 6.56193C2.63034 8.01193 3.36834 9.29293 4.49034 10.0429C3.82635 10.022 3.17698 9.84271 2.59634 9.51993V9.57193C2.59654 10.5376 2.93071 11.4735 3.54219 12.221C4.15367 12.9684 5.00483 13.4814 5.95134 13.6729C5.33496 13.84 4.68865 13.8646 4.06134 13.7449C4.32821 14.5762 4.84835 15.3031 5.54894 15.824C6.24952 16.3449 7.09547 16.6337 7.96834 16.6499C7.10082 17.3313 6.10752 17.8349 5.04522 18.1321C3.98293 18.4293 2.87247 18.5142 1.77734 18.3819C3.68904 19.6114 5.91444 20.264 8.18734 20.2619C15.8803 20.2619 20.0873 13.8889 20.0873 8.36193C20.0873 8.18193 20.0823 7.99993 20.0743 7.82193C20.8932 7.23009 21.5999 6.49695 22.1613 5.65693L22.1603 5.65593Z"
                                            fill="black"></path>
                                        <path
                                            d="M22.1603 5.65593C21.3969 5.99362 20.5873 6.2154 19.7583 6.31393C20.6321 5.79136 21.2861 4.96894 21.5983 3.99993C20.7783 4.48793 19.8793 4.82993 18.9423 5.01493C18.313 4.34151 17.4787 3.89489 16.5693 3.74451C15.6599 3.59413 14.7263 3.74842 13.9136 4.18338C13.1009 4.61834 12.4547 5.30961 12.0755 6.14972C11.6962 6.98983 11.6051 7.93171 11.8163 8.82893C10.1535 8.74558 8.52668 8.31345 7.04163 7.56059C5.55659 6.80773 4.24647 5.75097 3.19634 4.45893C2.82463 5.09738 2.6293 5.82315 2.63034 6.56193C2.63034 8.01193 3.36834 9.29293 4.49034 10.0429C3.82635 10.022 3.17698 9.84271 2.59634 9.51993V9.57193C2.59654 10.5376 2.93071 11.4735 3.54219 12.221C4.15367 12.9684 5.00483 13.4814 5.95134 13.6729C5.33496 13.84 4.68865 13.8646 4.06134 13.7449C4.32821 14.5762 4.84835 15.3031 5.54894 15.824C6.24952 16.3449 7.09547 16.6337 7.96834 16.6499C7.10082 17.3313 6.10752 17.8349 5.04522 18.1321C3.98293 18.4293 2.87247 18.5142 1.77734 18.3819C3.68904 19.6114 5.91444 20.264 8.18734 20.2619C15.8803 20.2619 20.0873 13.8889 20.0873 8.36193C20.0873 8.18193 20.0823 7.99993 20.0743 7.82193C20.8932 7.23009 21.5999 6.49695 22.1613 5.65693L22.1603 5.65593Z"
                                            fill="url(#paint0_linear_803_2139)"></path>
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_803_2139" x1="22.1613" y1="11.6798"
                                            x2="1.42682" y2="14.2565" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#00C4B8"></stop>
                                            <stop offset="1" stopColor="#0ACE88"></stop>
                                        </linearGradient>
                                        <clipPath id="clip0_803_2139">
                                            <rect width="24" height="24" fill="white"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>


                            </a>
                        </li>
                    </ul>  */}
            </nav>

          </div>
        </header>
      </div>

      <main>
        <section id="Start">
          <img className="banner__bg" src={bannerIMG} alt="img" />
          <div className="banner container">
            <div className="banner__inner">
              <p className="banner__pre-header">archon chain protocol’s</p>
              <h1 className="banner__title">ARCHON<br /><span className="acctent">NETWORK</span></h1>
              <p className="banner__paragraph">Decentralized protocol economy for scientific research, built on
                the
                foundation of a central bedrock principle - that of continuity of storage.
              </p>
              <div className="banner__btns">
                <a className="banner__btn" href="#ProtocolArchitecture">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_803_1158)">
                      <path
                        d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                        fill="#282D32" />
                      <path
                        d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                        fill="url(#paint0_linear_803_1158)" />
                    </g>
                    <defs>
                      <linearGradient id="paint0_linear_803_1158" x1="20.2787" y1="11.7149"
                        x2="4.36437" y2="13.2782" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#00C4B8" />
                        <stop offset="1" stopColor="#0ACE88" />
                      </linearGradient>
                      <clipPath id="clip0_803_1158">
                        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                      </clipPath>
                    </defs>
                  </svg>

                  Learn More
                </a>
                <a className="banner__btn disabled" href="#">
                  <svg width="25" height="24" style={{ display: 'none' }} viewBox="0 0 25 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_803_1163)">
                      <path
                        d="M18.864 5.63609L17.45 7.05009C16.3049 5.90489 14.7982 5.19215 13.1865 5.03333C11.5748 4.87451 9.95794 5.27942 8.61134 6.17908fC7.26474 7.07874 6.27174 8.41748 5.80154 9.9672C5.33134 11.5169 5.41302 13.1817 6.03268 14.678C6.65234 16.1742 7.77162 17.4093 9.19983 18.1728C10.628 18.9363 12.2768 19.181 13.8652 18.8652C15.4536 18.5493 16.8833 17.6925 17.9108 16.4407C18.9382 15.1889 19.4999 13.6196 19.5 12.0001H21.5C21.5 14.0823 20.778 16.1001 19.457 17.7096C18.1361 19.3192 16.2979 20.4209 14.2557 20.8271C12.2136 21.2333 10.0937 20.9188 8.25737 19.9373C6.42104 18.9557 4.98187 17.3678 4.18506 15.4441C3.38825 13.5204 3.28311 11.3799 3.88756 9.38739C4.492 7.39486 5.76863 5.67355 7.49992 4.51675C9.23121 3.35996 11.31 2.83925 13.3822 3.04336C15.4544 3.24746 17.3917 4.16375 18.864 5.63609V5.63609Z"
                        fill="#282D32" />
                      <path
                        d="M18.864 5.63609L17.45 7.05009C16.3049 5.90489 14.7982 5.19215 13.1865 5.03333C11.5748 4.87451 9.95794 5.27942 8.61134 6.17908C7.26474 7.07874 6.27174 8.41748 5.80154 9.9672C5.33134 11.5169 5.41302 13.1817 6.03268 14.678C6.65234 16.1742 7.77162 17.4093 9.19983 18.1728C10.628 18.9363 12.2768 19.181 13.8652 18.8652C15.4536 18.5493 16.8833 17.6925 17.9108 16.4407C18.9382 15.1889 19.4999 13.6196 19.5 12.0001H21.5C21.5 14.0823 20.778 16.1001 19.457 17.7096C18.1361 19.3192 16.2979 20.4209 14.2557 20.8271C12.2136 21.2333 10.0937 20.9188 8.25737 19.9373C6.42104 18.9557 4.98187 17.3678 4.18506 15.4441C3.38825 13.5204 3.28311 11.3799 3.88756 9.38739C4.492 7.39486 5.76863 5.67355 7.49992 4.51675C9.23121 3.35996 11.31 2.83925 13.3822 3.04336C15.4544 3.24746 17.3917 4.16375 18.864 5.63609V5.63609Z"
                        fill="url(#paint0_linear_803_1163)" />
                    </g>
                    <defs>
                      <linearGradient id="paint0_linear_803_1163" x1="21.5" y1="11.6792" x2="3.09561"
                        y2="13.5388" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#00C4B8" />
                        <stop offset="1" stopColor="#0ACE88" />
                      </linearGradient>
                      <clipPath id="clip0_803_1163">
                        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                  Whitepaper Coming Soon
                </a>
              </div>
            </div>
          </div>

          <div className="wrapper">
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
            <div className="firefly"></div>
          </div>

        </section>
        <section id="ProtocolArchitecture">
          <div className="protocol-architecture container two-col pt-30vh">
            <div className="left">
              <article>
                <h2 className="h2">
                  protocol<br /><span className="green-accent">Architecture</span>
                </h2>
                <p className="bold-paragraph pt-32px">
                  Archon Protocol consists of two, closely interwoven and complementary components: Archon
                  Chain and Archon DAO & Analytics.
                </p>

                <p className="regular-paragraph pt-16px">
                  The latter allows research groups to create and govern their own  <span className='dashed-decoration tooltip-hover' ref={buttonRef} onMouseEnter={() => handleHover(1)} onClick={() => handleClick(1)} onMouseLeave={() => handleOver(1)}>
                    decentralized organizations
                  </span> (DAOs) and equips qualified parties with a toolset to scrutinize DAO performance and
                  track
                  research activity, while Archon Chain provides key infrastructure necessary to
                  facilitate
                  secure data storage and access.



                </p>
                <>

                  {isVisible && <div className="tooltip-container" ref={tooltipRef}>
                    <div className="tooltip-arrow" data-popper-arrow></div>
                    <div className="tooltip-content">
                      Decentralized autonomous organizations do away with <b>central authority</b> element and replace it with community-led, <b>smart contract</b> structure.
                    </div>
                    {/* This is a tooltip */}
                  </div>}
                </>
                <div className="pt-32px">
                  <a className="btn-first-type section-scroll-btn" href="#ArchonChain">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_803_1158)">
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="#282D32" />
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="url(#paint0_linear_803_1158)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_803_1158" x1="20.2787" y1="11.7149"
                          x2="4.36437" y2="13.2782" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <clipPath id="clip0_803_1158">
                          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>

                    Archon Chain
                  </a>
                </div>

              </article>
            </div>
            <div className="right protocol-architecture__right">
              <img className="protocol-architecture__right-img" src={tableIMG} alt="img" />
              <div className="protocol-architecture__right-content">
                <p>
                  DAO & Analytics component of Archon
                  <br />
                  is currently in closed Beta
                </p>
                <a className="btn-second-type mt-48px"
                  href="mailto:dapp@archon.network?subject=Archon%20Beta%20request">
                  Request Early Access
                  {/* Whitepaper Coming Soon... */}
                </a>
              </div>
            </div>
          </div>
        </section>
        <section id="ArchonChain">
          <div className="archon-chain container two-col pt-30vh">
            <div className="left">
              <article>
                <h2 className="h2">
                  Archon <span className="green-accent">chain</span>
                </h2>
                <p className="bold-paragraph pt-32px">
                  Archon Chain is a decentralized storage ecosystem with its own token economy, designed
                  to
                  map out and parse complex scientific models and data sets.

                </p>


                <p className="regular-paragraph pt-16px hover-container">

                  The chain is built around the <span className='dashed-decoration tooltip-hover' ref={buttonRef2} onMouseEnter={() => handleHover(2)} onClick={() => handleClick(2)} onMouseLeave={() => handleOver(2)}>
                    Proof of Private Segment Storage
                  </span> algorithm, and its underlying
                  concept is based on the foundation of a central bedrock principle - that of continuity
                  of
                  storage.
                </p>

                <>

                  {isVisible2 && <div className="tooltip-container" ref={tooltipRef2}>
                    <div className="tooltip-arrow" data-popper-arrow></div>
                    <div className="tooltip-content">
                      On Archon, each DAO features its own <b>registry of storage</b> sectors where data is stored in the form of an encrypted <b>Directed Acyclic Graph</b>
                    </div>
                    {/* This is a tooltip */}
                  </div>}

                </>

                <p className="regular-paragraph pt-16px">

                  To that end, Archon utilizes an extensive, <span className='dashed-decoration tooltip-hover' ref={buttonRef3} onMouseEnter={() => handleHover(3)} onClick={() => handleClick(3)} onMouseLeave={() => handleOver(3)}>regenerative</span> network of validator nodes, where
                  independent and persistent points of storage are expected to preserve shared bits of
                  knowledge in perpetuity - process enforced through built-in incentive and disincentive <span className='dashed-decoration tooltip-hover' ref={buttonRef4} onMouseEnter={() => handleHover(4)} onClick={() => handleClick(4)} onMouseLeave={() => handleOver(4)}>mechanisms</span>.
                </p>

                <>
                  {isVisible3 && <div className="tooltip-container" ref={tooltipRef3}>
                    <div className="tooltip-arrow" data-popper-arrow></div>
                    <div className="tooltip-content">
                      Archon features a dynamic <b>Node Replacement</b> system where any and all <b>inactive</b> nodes are instantly purged from the network and replaced.

                    </div>
                    {/* This is a tooltip */}
                  </div>}
                  {isVisible4 && <div className="tooltip-container" ref={tooltipRef4}>
                    <div className="tooltip-arrow" data-popper-arrow></div>
                    <div className="tooltip-content">
                      Archon provides both <b>economic incentives</b> to store data, as well as an automatic <b>slashing mechanism</b> for nodes that fail to fulfil their role.

                    </div>
                    {/* This is a tooltip */}
                  </div>}
                </>

                <div className="pt-32px">
                  <a className="btn-first-type section-scroll-btn" href="#TheSocialElement">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_803_1158)">
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="#282D32" />
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="url(#paint0_linear_803_1158)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_803_1158" x1="20.2787" y1="11.7149"
                          x2="4.36437" y2="13.2782" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <clipPath id="clip0_803_1158">
                          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    More
                  </a>
                </div>

              </article>
            </div>
            <div className="right archon-chain__right-content">
              <img src={archonChainIMG} className="archon-chain__img" />
            </div>
          </div>
        </section>
        <div id="FirstDescripition">
          <div className="container archon-description">
            <img className="archon-description__img" src={archonTitleIMG} alt="img" />
            <div className="archon-description__content">
              <p>
                Archon aims to build a persistent framework wherein topic-focused and censorship-free
                scientific
                exploration is encouraged, properly recorded and rewarded, effectively ensuring that the
                essence
                of
                that knowledge remains available to future generations.
              </p>
              <div className="archon-description__btn-wrap mt-48px">
                <a className="btn-second-type"
                  href="mailto:dapp@archon.network?subject=Archon%20Beta%20request">
                  {/* Whitepaper Coming Soon... */}
                  Get in touch with us
                </a>
              </div>

            </div>

          </div>
        </div>
        <section id="TheSocialElement">
          <div className="the-social-element container two-col pt-30vh">
            <div className="left">
              <article>
                <h2 className="h2">
                  The Social <span className="green-accent">element</span>
                </h2>
                <p className="bold-paragraph pt-32px">
                  Archon takes cues from existing social media models, building a Web3 space that spurs
                  and
                  stimulates meaningful interactions between participating parties.
                </p>
                <p className="regular-paragraph pt-16px">

                  In such an environment, researchers are not only free to pursue uncensored scientific
                  inquiry, secure funding, and get rewarded for their efforts based on the merit of their
                  contributions, but can also cultivate their own spheres of influence - build up their
                  reputations and establish
                  networks of connections between themselves, other professionals and with communities.
                </p>


                <div className="pt-32px">
                  <a className="btn-first-type section-scroll-btn" href="#ResearchObjects">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_803_1158)">
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="#282D32" />
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="url(#paint0_linear_803_1158)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_803_1158" x1="20.2787" y1="11.7149"
                          x2="4.36437" y2="13.2782" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <clipPath id="clip0_803_1158">
                          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    More
                  </a>
                </div>

              </article>
            </div>
            <div className="right the-social-element__right-content">
              <img src={socialElementIMG} className="the-social-element__img" />
            </div>
          </div>
        </section>
        <section id="ResearchObjects">
          <div className="research-objects container two-col pt-30vh">
            <div className="left">
              <article>
                <h2 className="h2">
                  Research <span className="green-accent">Objects</span>
                </h2>
                <p className="bold-paragraph pt-32px">
                  Biolinks are Archon-native, interactive research objects that allow for creation of
                  high-level data models for biological, chemical and biomedical concepts.
                </p>
                <p className="regular-paragraph pt-16px">
                  Biolinks enable rich <span className='dashed-decoration tooltip-hover' ref={buttonRef5} onMouseEnter={() => handleHover(5)} onClick={() => handleClick(5)} onMouseLeave={() => handleOver(5)}>visualization of dependencies</span> between elements of research and
                  translate these intricate relationships into true, approachable statements about
                  reality.
                </p>
                <>
                  {isVisible5 && <div className="tooltip-container" ref={tooltipRef5}>
                    <div className="tooltip-arrow" data-popper-arrow></div>
                    <div className="tooltip-content">
                      Establishing a simple, <b>proven connection</b> - Genesis Link, between a pair of objects, allows for building potentially infinitely <b>complex relationships</b> inside research.
                    </div>
                    {/* This is a tooltip */}
                  </div>}
                </>
                <p className="regular-paragraph pt-16px">
                  All data presented in the form of Biolinks is stored on and accessed through Archon
                  Chain.
                </p>


                <div className="pt-32px">
                  <a className="btn-first-type section-scroll-btn" href="#EconomyOfParticipation">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_803_1158)">
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="#282D32" />
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="url(#paint0_linear_803_1158)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_803_1158" x1="20.2787" y1="11.7149"
                          x2="4.36437" y2="13.2782" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <clipPath id="clip0_803_1158">
                          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    More
                  </a>
                </div>

              </article>
            </div>
            <div className="right research-objects__right">
              <div className="research-objects__right-content">
                <p className="research-objects__quote-paragraph">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_803_705)">
                      <path
                        d="M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM10.962 8.1L10.515 7.412C8.728 8.187 7.5 9.755 7.5 11.505C7.5 12.5 7.777 13.114 8.292 13.661C8.616 14.005 9.129 14.25 9.666 14.25C10.632 14.25 11.416 13.466 11.416 12.5C11.416 11.58 10.705 10.839 9.802 10.755C9.642 10.74 9.478 10.743 9.323 10.765V10.673C9.329 10.251 9.415 9.04 10.777 8.207L10.962 8.1L10.515 7.412L10.962 8.1ZM15.515 7.412C13.728 8.187 12.5 9.755 12.5 11.505C12.5 12.5 12.777 13.114 13.292 13.661C13.616 14.005 14.129 14.25 14.666 14.25C15.632 14.25 16.416 13.466 16.416 12.5C16.416 11.58 15.705 10.839 14.802 10.755C14.642 10.74 14.478 10.743 14.323 10.765C14.323 10.452 14.294 9.003 15.962 8.1L15.515 7.412Z"
                        fill="#1CAE84" />
                    </g>
                    <defs>
                      <clipPath id="clip0_803_705">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Effect of intravenous adrenaline on electrocardiogram, blood...
                </p>
                <div className="divider"></div>
                <p className="research-objects__right-content-paragraph">
                  <span className='accent-text-bg'>Adrenaline</span> caused an increase in <span className='accent-text-bg'>systolic blood pressure</span>, a decrease in <span className='accent-text-bg'>diastolic blood pressure</span>, and an increase in <span className='accent-text-bg'>heart rate</span>. Adrenaline also produced a decrease in <span className='accent-text-bg'>T wave amplitude</span> and an increase in the <span className='accent-text-bg'>QTc interval</span>. <span className='accent-text-bg'>Serum potassium</span> fell dramatically
                  during the adrenaline infusion from a control value of 4.06 mmol/l to 3.22 mmol/l.
                </p>
                <div className="divider"></div>
                <div className="flex space-between">
                  <span>
                    341 characters
                  </span>
                  <span>
                    7 objects assigned to Biolink
                  </span>
                </div>
              </div>
              <p className="research-objects__source">
                Source: www.ncbi.nlm.nih.gov/pmc/articles/PMC485215/
              </p>
            </div>
          </div>
        </section>
        <section id="EconomyOfParticipation">
          <div className="economy-of-participation container two-col pt-30vh">
            <div className="left economy-of-participation__left">
              <article>
                <h2 className="h2">
                  economy of <span className="green-accent">participation</span>
                </h2>
                <p className="bold-paragraph pt-32px">
                  Archon aims to resuscitate the spirit of scientific inquiry, and foster a
                  community-driven environment where all research efforts remain to serve a purpose.
                </p>
                <p className="regular-paragraph pt-16px">

                  To that end, the protocol is trained to recognize active participation towards these
                  goals, in- and outside the platform, as well as encourage experimentation and promote
                  further involvement with NFT and token-based rewards.
                </p>

                <div className="pt-32px">
                  <a className="btn-first-type section-scroll-btn" href="#MaturityOfResearch">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_803_1158)">
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="#282D32" />
                        <path
                          d="M13.5007 16.172L18.8647 10.808L20.2787 12.222L12.5007 20L4.72266 12.222L6.13666 10.808L11.5007 16.172V4H13.5007V16.172Z"
                          fill="url(#paint0_linear_803_1158)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_803_1158" x1="20.2787" y1="11.7149"
                          x2="4.36437" y2="13.2782" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <clipPath id="clip0_803_1158">
                          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                    More
                  </a>
                </div>

              </article>
            </div>
            <div className="right economy-of-participation__right-content">
              <div className="economy-of-participation__right-content-img-wrap economy-of-participation__right-content-img">

                <video src='https://archon-assets.s3.amazonaws.com/2test.mp4'
                  type='video/mp4' data-replace-video-with-canvas autoPlay loop muted style={{ position: 'absolute', width: '100%', height: '100%', left: '0', top: '0', objectFit: 'contain', objectPosition: 'right center' }}></video>




                {/* <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span>
                <span className="diamond-lightness"></span> */}


              </div>

            </div>
          </div>
        </section>
        <section id="MaturityOfResearch">
          <div className="maturity-of-research container pt-30vh">
            <h2 className="h2 maturity-of-research__title">
              Maturity<br />of <span className="green-accent">Research</span>
            </h2>
            <div className="maturity-of-research__slider">
              <Swiper

                // spaceBetween={50}
                slidesPerView={'auto'}
                // modules={[Navigation, Pagination, Scrollbar, A11y]} // I want to focus here
                // spaceBetween={50}
                modules={[FreeMode, Navigation, Thumbs]}

                // slidesPerView={3}
                navigation
                // onSwiper={(swiper) => {
                //   // Delay execution for the refs to be defined
                //   setTimeout(() => {
                //     // Override prevEl & nextEl now that refs are defined
                //     swiper.params.navigation.prevEl = navigationPrevRef.current
                //     swiper.params.navigation.nextEl = navigationNextRef.current

                //     // Re-init navigation
                //     // swiper.navigation.destroy()
                //     swiper.navigation.init()
                //     swiper.navigation.update()
                //   })
                // }}
                // pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                // onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}

              // navigation={true}
              >
                <SwiperSlide className='m1 js-m1'>
                  <div className="swiper-slide__inner">
                    <img src={mature1} alt="img" />
                    <svg viewBox="0 0 209 272" className="js-svg" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M60.173 60.8652C37.0875 96.2877 44.1151 123.137 62.1834 143.482"
                        stroke="#08CB92" strokeWidth="2" strokeDasharray="4 4" />
                      <path className=""
                        d="M190.86 270.953L199.022 271.173L199.241 263.011L191.079 262.791L190.86 270.953ZM147.89 197.252C148.501 197.54 149.111 197.828 149.72 198.116L150.576 196.309C149.966 196.02 149.355 195.731 148.742 195.443L147.89 197.252ZM153.369 199.856C154.588 200.442 155.801 201.029 157.006 201.618L157.884 199.821C156.675 199.23 155.458 198.641 154.235 198.053L153.369 199.856ZM160.628 203.407C161.839 204.012 163.041 204.62 164.23 205.229L165.143 203.45C163.946 202.836 162.739 202.226 161.521 201.618L160.628 203.407ZM167.81 207.092C169.009 207.726 170.194 208.363 171.361 209.003L172.322 207.249C171.145 206.604 169.952 205.962 168.744 205.324L167.81 207.092ZM174.879 210.97C176.06 211.644 177.219 212.322 178.356 213.003L179.384 211.288C178.235 210.599 177.063 209.914 175.871 209.233L174.879 210.97ZM181.78 215.113C182.93 215.843 184.051 216.576 185.14 217.314L186.262 215.658C185.155 214.908 184.017 214.164 182.852 213.425L181.78 215.113ZM188.417 219.62C189.515 220.424 190.572 221.233 191.587 222.048L192.839 220.489C191.8 219.654 190.719 218.827 189.599 218.007L188.417 219.62ZM194.638 224.638C195.653 225.551 196.61 226.471 197.505 227.398L198.944 226.009C198.014 225.045 197.023 224.093 195.976 223.151L194.638 224.638ZM200.12 230.349C200.974 231.407 201.742 232.474 202.42 233.549L204.112 232.482C203.389 231.335 202.574 230.206 201.677 229.093L200.12 230.349ZM204.256 236.975C204.789 238.183 205.205 239.402 205.498 240.633L207.443 240.171C207.121 238.813 206.664 237.479 206.086 236.168L204.256 236.975ZM206.002 244.43C206.038 245.686 205.944 246.962 205.713 248.26L207.682 248.611C207.937 247.181 208.041 245.768 208.001 244.373L206.002 244.43ZM204.689 251.966C204.255 253.13 203.71 254.314 203.044 255.519L204.795 256.486C205.505 255.201 206.093 253.927 206.563 252.665L204.689 251.966ZM200.954 258.821C200.227 259.841 199.415 260.874 198.515 261.922L200.032 263.226C200.968 262.135 201.817 261.054 202.582 259.982L200.954 258.821ZM195.817 264.836C195.35 265.307 194.865 265.78 194.363 266.256L195.738 267.708C196.255 267.218 196.755 266.73 197.237 266.244L195.817 264.836Z"
                        fill="#08CB92" />
                      <circle className="js-m-click circle-fill" style={{ '--i': '0s', '--count': 2 }}
                        transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 60.1747 60.8661)" />
                      <circle cx="60.176" className="js-m-click circle-fill"
                        style={{ '--i': '1s', '--count': 2 }} cy="60.1741" />
                      <circle cx="60.175" className="js-m-click circle-fill"
                        style={{ '--i': '2s', '--count': 2 }} cy="60.175" />
                      <circle cx="60.1766" className="js-m-click circle-fill"
                        style={{ '--i': '3s', '--count': 2 }} cy="60.1746" />


                      <defs>
                        <linearGradient id="paint0_linear_810_10901" x1="91.9927" y1="59.0401"
                          x2="26.9298" y2="65.6139" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_810_10901" x1="120.35" y1="58.0302"
                          x2="-2.70381" y2="70.4633" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_810_10901" x1="72.6266" y1="59.7309"
                          x2="47.1672" y2="62.3032" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_810_10901" x1="5.53333" y1="2.66806"
                          x2="-0.124313" y2="3.23969" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="maturity-of-research__popup m1__popup">
                      <h4 className="maturity-of-research__popup-list-title">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_803_1320)">
                            <circle opacity="0.1" cx="12.0039" cy="12" r="7" stroke="white"
                              strokeWidth="2" />
                          </g>
                          <defs>
                            <clipPath id="clip0_803_1320">
                              <rect width="24" height="24" fill="white"
                                transform="translate(0.00390625)" />
                            </clipPath>
                          </defs>
                        </svg>
                        Drafts and Proposals
                      </h4>
                      <ul className="maturity-of-research__popup-list">
                        <li className="maturity-of-research__popup-item">Unpolished</li>
                        <li className="maturity-of-research__popup-item">Mostly discussion-based
                        </li>
                        <li className="maturity-of-research__popup-item">Not reviewed/approved</li>
                      </ul>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className='m2 js-m2'>
                  <div className="swiper-slide__inner">

                    <img src={mature2} alt="img" />
                    <svg width="150" className="js-svg" height="294" viewBox="0 0 150 294" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M140.984 293.608L137.307 286.318L144.597 282.641L148.274 289.931L140.984 293.608ZM116.767 183.759C117.281 184.202 117.795 184.654 118.309 185.114L116.975 186.605C116.47 186.153 115.965 185.709 115.46 185.272L116.767 183.759ZM121.327 187.914C122.304 188.853 123.277 189.823 124.242 190.823L122.802 192.211C121.855 191.23 120.9 190.278 119.941 189.355L121.327 187.914ZM127.046 193.845C127.95 194.859 128.844 195.902 129.724 196.973L128.179 198.243C127.316 197.193 126.44 196.171 125.553 195.176L127.046 193.845ZM132.275 200.215C133.095 201.303 133.899 202.419 134.684 203.562L133.036 204.695C132.267 203.576 131.48 202.484 130.678 201.418L132.275 200.215ZM136.942 207.012C137.663 208.171 138.364 209.355 139.042 210.567L137.297 211.544C136.635 210.36 135.949 209.202 135.244 208.069L136.942 207.012ZM140.975 214.218C141.583 215.438 142.168 216.682 142.727 217.952L140.897 218.758C140.351 217.518 139.78 216.302 139.185 215.111L140.975 214.218ZM144.297 221.77C144.784 223.044 145.245 224.341 145.677 225.663L143.777 226.285C143.355 224.995 142.905 223.728 142.429 222.485L144.297 221.77ZM146.864 229.621C147.224 230.936 147.554 232.274 147.855 233.634L145.902 234.065C145.608 232.737 145.286 231.432 144.935 230.148L146.864 229.621ZM148.646 237.682C148.874 239.022 149.073 240.383 149.241 241.765L147.255 242.006C147.091 240.656 146.897 239.327 146.674 238.018L148.646 237.682ZM149.642 245.87C149.743 247.224 149.814 248.597 149.854 249.989L147.855 250.047C147.816 248.685 147.746 247.342 147.648 246.019L149.642 245.87ZM149.882 254.112C149.862 255.468 149.813 256.841 149.733 258.232L147.736 258.117C147.814 256.755 147.863 255.41 147.883 254.082L149.882 254.112ZM149.413 262.34C149.281 263.688 149.121 265.052 148.931 266.432L146.95 266.16C147.136 264.805 147.293 263.467 147.423 262.145L149.413 262.34ZM148.295 270.503C148.061 271.837 147.8 273.186 147.511 274.549L145.555 274.135C145.839 272.794 146.095 271.469 146.325 270.157L148.295 270.503ZM146.591 278.561C146.268 279.87 145.919 281.192 145.544 282.527L143.619 281.987C143.988 280.672 144.331 279.37 144.649 278.081L146.591 278.561ZM144.375 286.461C144.17 287.117 143.958 287.776 143.74 288.438L141.841 287.812C142.056 287.159 142.264 286.51 142.467 285.863L144.375 286.461Z"
                        fill="#08CB92" />
                      <path d="M60.4821 60.1738C57.1892 75.2725 56.3489 88.0213 57.3689 98.9895"
                        stroke="#08CB92" strokeWidth="2" strokeDasharray="4 4" />
                      <circle className="js-m-click circle-fill" style={{ '--i': '0s', '--count': 2 }}
                        transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 60.1747 60.8661)" />
                      <circle cx="60.176" className="js-m-click circle-fill"
                        style={{ '--i': '1s', '--count': 2 }} cy="60.1741" />
                      <circle cx="60.175" className="js-m-click circle-fill"
                        style={{ '--i': '2s', '--count': 2 }} cy="60.175" />
                      <circle cx="60.1766" className="js-m-click circle-fill"
                        style={{ '--i': '3s', '--count': 2 }} cy="60.1746" />


                      <defs>
                        <linearGradient id="paint0_linear_810_10911" x1="92.9883" y1="59.0401"
                          x2="27.9253" y2="65.6139" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_810_10911" x1="121.348" y1="58.0302"
                          x2="-1.70616" y2="70.4633" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_810_10911" x1="73.6211" y1="59.7309"
                          x2="48.1617" y2="62.3032" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_810_10911" x1="5.53333" y1="2.66806"
                          x2="-0.124313" y2="3.23969" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="maturity-of-research__popup m2__popup">
                      <h4 className="maturity-of-research__popup-list-title">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <circle opacity="0.1" cx="12.0117" cy="12" r="7" stroke="white"
                            strokeWidth="2" />
                          <path
                            d="M12.0117 5C13.3962 5 14.7496 5.41054 15.9007 6.17971C17.0519 6.94888 17.9491 8.04213 18.4789 9.32122C19.0087 10.6003 19.1473 12.0078 18.8772 13.3656C18.6071 14.7235 17.9404 15.9708 16.9615 16.9497"
                            stroke="#1CAE84" strokeWidth="2" strokeLinecap="round" />
                        </svg>

                        First Major Release
                      </h4>
                      <ul className="maturity-of-research__popup-list">
                        <li className="maturity-of-research__popup-item">Single review threshold
                        </li>
                        <li className="maturity-of-research__popup-item">Version 1.0+</li>

                      </ul>
                    </div>

                  </div>
                </SwiperSlide>
                <SwiperSlide className='m3 js-m3'>
                  <div className="swiper-slide__inner">

                    <img src={mature3} alt="img" />
                    <svg width="250" className="js-svg" height="224" viewBox="0 0 250 224" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M190.035 138.482C223.72 225.731 173.969 238.833 115.627 204.519"
                        stroke="#08CB92" strokeWidth="2" strokeDasharray="4 4" />
                      <path
                        d="M8.22807 0.421436L1.16191 4.51241L5.25287 11.5786L12.319 7.4876L8.22807 0.421436ZM5.77424 5.74234C5.59612 6.41029 5.42193 7.07651 5.25169 7.74101L7.18913 8.23735C7.35772 7.57926 7.53025 6.91937 7.70671 6.25766L5.77424 5.74234ZM4.27142 11.7357C3.95602 13.0811 3.6574 14.4196 3.37578 15.7515L5.33251 16.1652C5.61104 14.848 5.90648 13.5237 6.21863 12.1922L4.27142 11.7357ZM2.57081 19.7879C2.31644 21.1467 2.08037 22.4986 1.86286 23.8441L3.83723 24.1633C4.05204 22.8345 4.28526 21.4988 4.53666 20.1559L2.57081 19.7879ZM1.25849 27.9187C1.07381 29.2889 0.909024 30.6525 0.764411 32.0098L2.75315 32.2217C2.89576 30.8832 3.05831 29.5381 3.24057 28.1858L1.25849 27.9187ZM0.38736 36.115C0.281319 37.4933 0.196767 38.8652 0.134 40.2312L2.13189 40.323C2.1937 38.978 2.27698 37.6266 2.38147 36.2684L0.38736 36.115ZM0.0107566 44.3546C-0.00803843 45.736 -0.00384454 47.1114 0.0236531 48.4812L2.02325 48.4411C1.99621 47.0941 1.99208 45.7411 2.01057 44.3819L0.0107566 44.3546ZM0.178135 52.606C0.253987 53.9839 0.354131 55.3563 0.478892 56.7236L2.47062 56.5419C2.34806 55.1988 2.24966 53.8503 2.17511 52.496L0.178135 52.606ZM0.929681 60.8284C1.10545 62.1951 1.30651 63.557 1.53318 64.9142L3.50586 64.5847C3.28334 63.2524 3.08594 61.9154 2.91334 60.5733L0.929681 60.8284ZM2.29086 68.9748C2.56889 70.3221 2.8728 71.6651 3.20291 73.0041L5.14477 72.5254C4.82077 71.2111 4.52248 69.893 4.24959 68.5706L2.29086 68.9748ZM4.26822 76.9959C4.64748 78.3155 5.05277 79.6316 5.48439 80.9444L7.38433 80.3197C6.96056 79.0308 6.56269 77.7388 6.19042 76.4435L4.26822 76.9959ZM6.84765 84.8439C7.32358 86.1282 7.82522 87.4097 8.35286 88.6886L10.2017 87.9259C9.68325 86.6692 9.19047 85.4104 8.72303 84.1489L6.84765 84.8439ZM9.99487 92.4759C10.5606 93.7203 11.1514 94.9625 11.7675 96.2028L13.5587 95.3131C12.9527 94.093 12.3717 92.8715 11.8155 91.6482L9.99487 92.4759ZM13.6642 99.8671C14.3113 101.068 14.9825 102.268 15.678 103.467L17.4079 102.463C16.7228 101.283 16.062 100.101 15.425 98.9187L13.6642 99.8671ZM17.8019 107.002C18.5212 108.16 19.2636 109.317 20.0291 110.473L21.6966 109.369C20.9416 108.228 20.2097 107.088 19.5006 105.947L17.8019 107.002ZM22.3517 113.878C23.1332 114.99 23.9363 116.103 24.7614 117.215L26.3677 116.023C25.5528 114.925 24.7598 113.826 23.9884 112.728L22.3517 113.878ZM27.2535 120.489C28.0893 121.56 28.9455 122.63 29.8224 123.701L31.3699 122.435C30.5027 121.375 29.6561 120.316 28.8301 119.258L27.2535 120.489ZM32.4629 126.855C32.9095 127.377 33.361 127.899 33.8175 128.421L35.3231 127.104C34.8712 126.587 34.4243 126.071 33.9823 125.554L32.4629 126.855Z"
                        fill="#08CB92" />
                      <circle r="31.8167" className="js-m-click circle-fill"
                        style={{ '--i': '0s', '--count': 2 }}
                        transform="matrix(4.37114e-08 1 1 -4.37114e-08 189.344 138.483)" />
                      <circle r="60.175" className="js-m-click circle-fill"
                        style={{ '--i': '1s', '--count': 2 }}
                        transform="matrix(4.37114e-08 1 1 -4.37114e-08 189.343 138.484)" />
                      <circle r="12.45" className="js-m-click circle-fill"
                        style={{ '--i': '2s', '--count': 2 }}
                        transform="matrix(4.37114e-08 1 1 -4.37114e-08 189.345 138.483)" />

                      <circle cx="190.034" className="js-m-click circle-fill"
                        style={{ '--i': '3s', '--count': 2 }} cy="138.483"
                        transform="rotate(180 190.034 138.483)" />
                      <defs>
                        <linearGradient id="paint0_linear_810_10925" x1="63.6333" y1="30.6826"
                          x2="-1.4296" y2="37.2564" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_810_10925" x1="120.35" y1="58.0302"
                          x2="-2.70381" y2="70.4633" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_810_10925" x1="24.9" y1="12.0063"
                          x2="-0.559409" y2="14.5786" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_810_10925" x1="192.801" y1="138.385"
                          x2="187.143" y2="138.956" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#00C4B8" />
                          <stop offset="1" stopColor="#0ACE88" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="maturity-of-research__popup m3__popup">
                      <h4 className="maturity-of-research__popup-list-title">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_803_1306)">
                            <circle opacity="0.1" cx="12.9961" cy="12" r="7" stroke="white"
                              strokeWidth="2" />
                            <path
                              d="M12.9961 5C14.5288 5 16.0191 5.50304 17.2383 6.43189C18.4574 7.36073 19.3381 8.66405 19.7449 10.1417C20.1518 11.6194 20.0625 13.1898 19.4906 14.6118C18.9187 16.0338 17.8959 17.2288 16.5793 18.0134C15.2626 18.7979 13.7248 19.1287 12.202 18.9548C10.6792 18.781 9.25559 18.1121 8.14966 17.0509C7.04373 15.9898 6.31664 14.595 6.08002 13.0807C5.8434 11.5664 6.11032 10.0163 6.83981 8.6683"
                              stroke="#1CAE84" strokeWidth="2" strokeLinecap="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_803_1306">
                              <rect width="24" height="24" fill="white"
                                transform="translate(0.996094)" />
                            </clipPath>
                          </defs>
                        </svg>
                        Subsequent Releases
                      </h4>
                      <ul className="maturity-of-research__popup-list">
                        <li className="maturity-of-research__popup-item">Passed multiple reviews
                        </li>
                        <li className="maturity-of-research__popup-item">Multiple collaborators</li>
                        <li className="maturity-of-research__popup-item">Version 2.0+</li>
                      </ul>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>


            </div>

            <div className="maturity-of-research__paragaph-wrap">
              <p className="bold-paragraph">
                Publications on Archon take the form of on-chain knowledge shards, and visually translate
                the
                maturity of research.
              </p>
              <p className="regular-paragraph">
                Each iteration takes a more geometric and familiar shape.
              </p>
            </div>
          </div>
        </section>

        <div id="SecondDescripition">
          <div className="container archon-description ">
            <img className="archon-description__img" src={archonTitleIMG} alt="img" />
            <div className="archon-description__content">
              <p>
                Join our community, get access to cutting-edge technology - including a demo of the
                protocol,
                and help us see Archon grow, mature, and reach its full, grassroot potential.
                <br />
                <b>Let’s build the future of DeSci together.</b>
              </p>
              <div className="mt-48px">
                <a className="btn-second-type"
                  href="mailto:dapp@archon.network?subject=Archon%20Beta%20request">
                  Get in touch with us
                  {/* Whitepaper Coming Soon...  */}
                </a>
              </div>

            </div>

          </div>
        </div>

        {/* <div id="Socials">
                <div className="socials container">
                    <ul className="socials__list">
                        <li className="socials__item">
                            <a className="socials__link" href="#">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_803_2136)">
                                        <path
                                            d="M18.335 18.339H15.67V14.162C15.67 13.166 15.65 11.884 14.28 11.884C12.891 11.884 12.679 12.968 12.679 14.089V18.339H10.013V9.75H12.573V10.92H12.608C12.966 10.246 13.836 9.533 15.136 9.533C17.836 9.533 18.336 11.311 18.336 13.624V18.339H18.335ZM7.003 8.575C6.79956 8.57526 6.59806 8.53537 6.41006 8.45761C6.22207 8.37984 6.05127 8.26574 5.90746 8.12184C5.76365 7.97793 5.64965 7.80706 5.57201 7.61901C5.49437 7.43097 5.4546 7.22944 5.455 7.026C5.4552 6.71983 5.54618 6.4206 5.71644 6.16615C5.8867 5.91169 6.12859 5.71343 6.41153 5.59645C6.69447 5.47947 7.00574 5.44902 7.30598 5.50894C7.60622 5.56886 7.88196 5.71647 8.09831 5.93311C8.31466 6.14974 8.46191 6.42566 8.52145 6.72598C8.58099 7.0263 8.55013 7.33753 8.43278 7.62032C8.31544 7.9031 8.11687 8.14474 7.86219 8.31467C7.60751 8.4846 7.30817 8.5752 7.002 8.575H7.003ZM8.339 18.339H5.666V9.75H8.34V18.339H8.339ZM19.67 3H4.329C3.593 3 3 3.58 3 4.297V19.703C3 20.42 3.594 21 4.328 21H19.666C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3H19.669H19.67Z"
                                            fill="rgba(0, 196, 184, 1)" />
                                        <path
                                            d="M18.335 18.339H15.67V14.162C15.67 13.166 15.65 11.884 14.28 11.884C12.891 11.884 12.679 12.968 12.679 14.089V18.339H10.013V9.75H12.573V10.92H12.608C12.966 10.246 13.836 9.533 15.136 9.533C17.836 9.533 18.336 11.311 18.336 13.624V18.339H18.335ZM7.003 8.575C6.79956 8.57526 6.59806 8.53537 6.41006 8.45761C6.22207 8.37984 6.05127 8.26574 5.90746 8.12184C5.76365 7.97793 5.64965 7.80706 5.57201 7.61901C5.49437 7.43097 5.4546 7.22944 5.455 7.026C5.4552 6.71983 5.54618 6.4206 5.71644 6.16615C5.8867 5.91169 6.12859 5.71343 6.41153 5.59645C6.69447 5.47947 7.00574 5.44902 7.30598 5.50894C7.60622 5.56886 7.88196 5.71647 8.09831 5.93311C8.31466 6.14974 8.46191 6.42566 8.52145 6.72598C8.58099 7.0263 8.55013 7.33753 8.43278 7.62032C8.31544 7.9031 8.11687 8.14474 7.86219 8.31467C7.60751 8.4846 7.30817 8.5752 7.002 8.575H7.003ZM8.339 18.339H5.666V9.75H8.34V18.339H8.339ZM19.67 3H4.329C3.593 3 3 3.58 3 4.297V19.703C3 20.42 3.594 21 4.328 21H19.666C20.4 21 21 20.42 21 19.703V4.297C21 3.58 20.4 3 19.666 3H19.669H19.67Z"
                                            fill="url(#paint0_linear_803_2136)" />
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_803_2136" x1="21" y1="11.6792" x2="2.59561"
                                            y2="13.5388" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#00C4B8" />
                                            <stop offset="1" stopColor="#0ACE88" />
                                        </linearGradient>
                                        <clipPath id="clip0_803_2136">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </a>
                        </li>
                        <li className="socials__item">
                            <a className="socials__link" href="#">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_803_2139)">
                                        <path
                                            d="M22.1603 5.65593C21.3969 5.99362 20.5873 6.2154 19.7583 6.31393C20.6321 5.79136 21.2861 4.96894 21.5983 3.99993C20.7783 4.48793 19.8793 4.82993 18.9423 5.01493C18.313 4.34151 17.4787 3.89489 16.5693 3.74451C15.6599 3.59413 14.7263 3.74842 13.9136 4.18338C13.1009 4.61834 12.4547 5.30961 12.0755 6.14972C11.6962 6.98983 11.6051 7.93171 11.8163 8.82893C10.1535 8.74558 8.52668 8.31345 7.04163 7.56059C5.55659 6.80773 4.24647 5.75097 3.19634 4.45893C2.82463 5.09738 2.6293 5.82315 2.63034 6.56193C2.63034 8.01193 3.36834 9.29293 4.49034 10.0429C3.82635 10.022 3.17698 9.84271 2.59634 9.51993V9.57193C2.59654 10.5376 2.93071 11.4735 3.54219 12.221C4.15367 12.9684 5.00483 13.4814 5.95134 13.6729C5.33496 13.84 4.68865 13.8646 4.06134 13.7449C4.32821 14.5762 4.84835 15.3031 5.54894 15.824C6.24952 16.3449 7.09547 16.6337 7.96834 16.6499C7.10082 17.3313 6.10752 17.8349 5.04522 18.1321C3.98293 18.4293 2.87247 18.5142 1.77734 18.3819C3.68904 19.6114 5.91444 20.264 8.18734 20.2619C15.8803 20.2619 20.0873 13.8889 20.0873 8.36193C20.0873 8.18193 20.0823 7.99993 20.0743 7.82193C20.8932 7.23009 21.5999 6.49695 22.1613 5.65693L22.1603 5.65593Z"
                                            fill="rgba(0, 196, 184, 1)" />
                                        <path
                                            d="M22.1603 5.65593C21.3969 5.99362 20.5873 6.2154 19.7583 6.31393C20.6321 5.79136 21.2861 4.96894 21.5983 3.99993C20.7783 4.48793 19.8793 4.82993 18.9423 5.01493C18.313 4.34151 17.4787 3.89489 16.5693 3.74451C15.6599 3.59413 14.7263 3.74842 13.9136 4.18338C13.1009 4.61834 12.4547 5.30961 12.0755 6.14972C11.6962 6.98983 11.6051 7.93171 11.8163 8.82893C10.1535 8.74558 8.52668 8.31345 7.04163 7.56059C5.55659 6.80773 4.24647 5.75097 3.19634 4.45893C2.82463 5.09738 2.6293 5.82315 2.63034 6.56193C2.63034 8.01193 3.36834 9.29293 4.49034 10.0429C3.82635 10.022 3.17698 9.84271 2.59634 9.51993V9.57193C2.59654 10.5376 2.93071 11.4735 3.54219 12.221C4.15367 12.9684 5.00483 13.4814 5.95134 13.6729C5.33496 13.84 4.68865 13.8646 4.06134 13.7449C4.32821 14.5762 4.84835 15.3031 5.54894 15.824C6.24952 16.3449 7.09547 16.6337 7.96834 16.6499C7.10082 17.3313 6.10752 17.8349 5.04522 18.1321C3.98293 18.4293 2.87247 18.5142 1.77734 18.3819C3.68904 19.6114 5.91444 20.264 8.18734 20.2619C15.8803 20.2619 20.0873 13.8889 20.0873 8.36193C20.0873 8.18193 20.0823 7.99993 20.0743 7.82193C20.8932 7.23009 21.5999 6.49695 22.1613 5.65693L22.1603 5.65593Z"
                                            fill="url(#paint0_linear_803_2139)" />
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_803_2139" x1="22.1613" y1="11.6798"
                                            x2="1.42682" y2="14.2565" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#00C4B8" />
                                            <stop offset="1" stopColor="#0ACE88" />
                                        </linearGradient>
                                        <clipPath id="clip0_803_2139">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>


                            </a>
                        </li>
                    </ul>
                </div>
            </div>  */}

        <div style={{ paddingBottom: '78px' }}>
          <div className="container" style={{ textAlign: 'center', maxWidth: '510px' }}>
            <div className="divider"></div>
            <p style={{ color: '#ffffff' }}>
              Enter credentials and get temporary access to the exclusive Archon-X demo
            </p>
            <div style={{ marginTop: '36px' }}>
              <a className="btn-second-type" href="https://app.archon.network/">
                Sign in
              </a>
            </div>
            <div className="divider"></div>
            <p style={{ color: '#ffffff' }}>
              Not authorized yet?<br />
              Send us an e-mail and request access
            </p>
            <div className="">
              <a className="dashed-decoration" style={{ color: '#ffffff' }} href="mailto:dapp@archon.network">
                dapp@archon.network
              </a>
            </div>
          </div>

        </div>
      </main>
      <footer>
      </footer>
    </div >
  );
}

export default App;
